import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import MiniCardContainer from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/mini-card';
import { formatCustomerGroup } from '@loomstateorg/shared-frontend/helpers/formatter';
import { ALL_USERS_TAG } from 'helpers/hooks/usePermissionsChecker';

interface Props {
  data: any;
  customerGroup: any;
}

const MiniCardTastic: React.FC<Props> = ({ data, customerGroup }) => {
  if (!data) {
    return <div>Loading...</div>;
  }
  const fields = data?.data?.dataSource?.items[0]?.fields; // TODO: Check items array
  const categoryCards = data?.data?.dataSource?.items[0]?.fields?.categoryCards;

  const titleInfo = {
    mcTitle: fields?.categoryTitle,
    rightText: fields?.rightText,
    linkText: fields?.linkText,
    linkUrl: fields?.linkUrl,
    titleFontSize: fields?.titleFontSize,
  };

  const formattedCustomerGroup = formatCustomerGroup(customerGroup?.obj?.key!);

  const filteredData = categoryCards?.filter((item: { metadata: { tags: any[] } }) =>
    item.metadata?.tags?.some((tag) => tag.sys.id === formattedCustomerGroup || tag.sys.id === ALL_USERS_TAG),
  );

  const miniCards = filteredData?.map((obj: any) => ({
    text: obj?.fields?.categoryTitle,
    href: obj?.fields?.categoryLink,
    icon: obj?.fields?.categoryIcon,
    backgroundColor: obj?.fields?.backgroundColor,
    backgroundHoverColor: obj?.fields?.backgroundHoverColor,
    categoryFontSize: obj?.fields?.categoryFontSize,
    categoryColor: obj?.fields?.categoryColor,
    backgroundImage: obj?.fields?.backgroundImage,
    contentVerticalAlign: obj?.fields?.contentVerticalAlign,
    contentHorizontalAlign: obj?.fields?.contentHorizontalAlign,
    contentDirection: obj?.fields?.contentDirection,
  }));

  const cardsData = {
    titleInfo,
    miniCards,
  };

  return <MiniCardContainer {...cardsData} titleRightClassName={CHIPOTLE_CONTENT_LOOK.miniCardTitleRightClassName} />;
};

export default MiniCardTastic;
